// acciones
export const SAGA_GET_PROMOCIONES = 'promocionesReducer/SAGA_GET_PROMOCIONES'
export const SAVE_PROMOCIONES = 'promocionesReducer/SAVE_PROMOCIONES'
export const GET_PROMOCION_EDIT = 'promocionesReducer/GET_PROMOCION_EDIT'
export const SAVE_PROMOCION_EDIT = 'promocionesReducer/SAVE_PROMOCION_EDIT'
export const SAGA_SAVE_PROMOCIONES = 'promocionesReducer/SAGA_SAVE_PROMOCIONES'
export const SAGA_ELIMINAR_PROMOCIONES = 'promocionesReducer/SAGA_ELIMINAR_PROMOCIONES'

export const SAGA_IMAGEN_PROMOCIONES = 'promocionesReducer/SAGA_IMAGEN_PROMOCIONES'
export const SAGA_SAVE_IMAGEN_PROMOCIONES = 'promocionesReducer/SAGA_SAVE_IMAGEN_PROMOCIONES'
export const SAGA_ELIMINAR_IMAGEN_PROMOCIONES = 'promocionesReducer/SAGA_ELIMINAR_IMAGEN_PROMOCIONES'
export const SAVE_IMAGEN_PROMOCIONES = 'promocionesReducer/SAVE_IMAGEN_PROMOCIONES'

// funciones

export const sagaGetPromociones = () =>({
    type: SAGA_GET_PROMOCIONES
})
export const savePromociones = (payload) =>({
    type: SAVE_PROMOCIONES,
    payload
})
export const getPromocionEdit = (id) =>({
    type: GET_PROMOCION_EDIT,
    id
})
export const sagaEliminarPromocion = (id) =>({
    type: SAGA_ELIMINAR_PROMOCIONES,
    id
})
export const savePromocionEdit = (payload) =>({
    type: SAVE_PROMOCION_EDIT,
    payload
})

export const sagaSavePromociones = (payload) =>({
    type: SAGA_SAVE_PROMOCIONES,
    payload
})

/**media */

export const sagaImagenPromociones = () =>({
    type: SAGA_IMAGEN_PROMOCIONES
})

export const sagaSaveImagenPromociones = (payload) =>({
    type: SAGA_SAVE_IMAGEN_PROMOCIONES,
    payload
})

export const sagaEliminarImagenPromociones = (payload) =>({
    type: SAGA_ELIMINAR_IMAGEN_PROMOCIONES,
    payload
})

export const saveImagenPromociones = (payload) =>({
    type: SAVE_IMAGEN_PROMOCIONES,
    payload
})


